import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {updateControl} from '../../actions/control'
import {showLiveViewModal} from '../../utils/liveViewModal'
import {resetControl} from '../../utils/resetControl'
import find from 'lodash/find'
import FloatingNPControl from '../../components/liveView/FloatingNPControl'

//This is the minimised live view

class FloatingNPControlContainer extends Component {


	constructor() {
		super()		
		this.stopLiveView=this.stopLiveView.bind(this)
	}

	
 

 
	stopLiveView(){
		this.props.resetControl()
	}



	render() {
		const {control,section}=this.props
		var nowPlaying=false
		//var nowPlayingSection=null
		if(control){
			if (control.setPoll || control.currentPoll) {
				nowPlaying=true
				//nowPlayingSection=find(this.props.sections,{'id':control.section})
			}
		}



		const {location}=this.props.history
		if(!(location.pathname.indexOf('/liveview')>-1) && location.hash!='#now-playing' && !(location.pathname.indexOf('/classRoster')>-1) && !(location.pathname.indexOf('/scan-helper')>-1) && !this.props.liveViewNotification && nowPlaying)
		{
		
			return( 
				<FloatingNPControl 
					section={section}
					showLiveViewModal={showLiveViewModal}
					stopLiveView={this.stopLiveView}
					control={control}
				/>
			)
			
			
		}else return null
	}
}


function mapStateToProps(state) {
	var control=state.control
	let section=null
	if(state.control){
		section=find(state.sections, {'id':state.control.section})
		//currentPoll= find(state.queueQuestionPolls, {'id':control.currentPoll}) || find(state.historyQuestionPolls, {'id':control.currentPoll}) 
	}

	return {
		 control:control,
		 section:section,
		 pusherPoll:state.pusherPoll,
		 liveViewNotification:state.liveViewNotification,
	}
}




export default withRouter(connect(
	 mapStateToProps,
	{ updateControl,
	
		resetControl
	}
)(FloatingNPControlContainer))






// WEBPACK FOOTER //
// ./src/containers/liveView/FloatingNPControlContainer.js